import { createContext, useContext } from 'react';

/**
 * @typedef {Object} PaneViewerContextValue
 * @property {Object} step - Current step information
 * @property {Object} phase - Current phase information including progress
 * @property {boolean} nextEnabled - Whether the next button is enabled
 * @property {Function} onNext - Function to go to the next step
 * @property {boolean} inSession - Whether in session mode
 * @property {boolean} showNext - Whether to show the Next button
 * @property {Function} setShowNext - Function to toggle visibility of the Next button
 * @property {Function} setStepMetadata - Function to update step metadata
 * @property {string} nextButtonText - The text to display on the Next button
 * @property {Function} setNextButtonText - Function to set the text of the Next button and optionally show it
 * @property {boolean} hideTitle - Whether to hide the title section
 * @property {Function} setHideTitle - Function to toggle visibility of the title section
 * @property {Function} setIsTaskComplete - Function to mark the current task as complete
 */

/** @type {React.Context<PaneViewerContextValue | null>} */
const PaneViewerContext = createContext(/** @type {PaneViewerContextValue | null} */(null));

export const usePaneViewer = () => {
  const context = useContext(PaneViewerContext);
  if (!context) {
    throw new Error('usePaneViewer must be used within a PaneViewer');
  }
  return context;
};

export default PaneViewerContext;
